
export const initHiddentext = () => {
  const btn = document.querySelector('.btn_show_hidden_text')
  if (!btn)
    return

  const hiddenText = document.querySelector('.hidden_text')

  let isOpen = false

  btn.addEventListener('click', function () {
    if (!isOpen) {
      hiddenText.style.maxHeight = hiddenText.scrollHeight + 'px'
      isOpen = true
    } else {
      hiddenText.style.maxHeight = null
      isOpen = false
    }
  })
}
